import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { LandingPageComponent } from '@/public/landing-page/landing-page.component';



// export const appRoutes: Routes = [
//     {
//         path: '',
//         component: LandingPageComponent,

//     },
//     {
//         path: 'admin',
//         loadChildren: () => import('@/protected/protected.routes')
//     },
//     {
//         path: 'vendorside',
//         loadChildren: () => import('@/protected/protected.routes')
//     },

//     {
//         path: 'vendor',
//         children: [
//             { path: '', redirectTo: '/onboarding', pathMatch: 'full' },
//             {
//                 path: 'onboarding',
//                 data: { breadcrumb: 'Vendor' },
//                 loadChildren: () => import('@/public/public.routes')
//             },
//         ]
//     },
//     { path: '**', redirectTo: 'vendor/onboarding/login' }
// ];


export const appRoutes: Routes = [

    // {
    //     path: '',
    //     component: LandingPageComponent,

    // },
    // {
    //     path: 'admin', children: [
    //         { path: '', redirectTo: '/login', pathMatch: 'full' },
    //         {
    //             path: 'login',
    //             data: { breadcrumb: 'Admin' },
    //             loadChildren: () => import('@/public/public.routes')
    //         },
    //         {
    //         path: 'protected', canActivate: [authGuard],
    //         loadChildren: () => import('@/protected/protected.routes')
    //         }
    //     ]
    // },
    // {
    //     path: 'vendorside',
    //     loadChildren: () => import('@/protected/protected.routes')
    // },

    // {
    //     path: 'vendor',
    //     children: [
    //         { path: '', redirectTo: '/onboarding', pathMatch: 'full' },
    //         {
    //             path: 'onboarding',
    //             data: { breadcrumb: 'Vendor' },
    //             loadChildren: () => import('@/public/public.routes')
    //         },
    //     ]
    // },
    // { path: '**', redirectTo: 'vendor/onboarding/login' }

    {
        path: '',
        children: [
            { path: '', redirectTo: '/login', pathMatch: 'full' },
            {
                path: 'login',
                data: { breadcrumb: 'Admin' },
                loadChildren: () => import('@/public/public.routes')
            },
        ]
    },
    {path:'admin', canActivate: [authGuard], loadChildren:()=> import('@/protected/protected.routes') },
    { path: '**', redirectTo: 'login' }
];
